<template>
  <div class="calendar-single-page">
    <!-- Debug Info (only if debug enabled) -->
    <div v-if="DEBUG_CONFIG.showCalendarSingleDebug" style="background: yellow; padding: 10px; margin-bottom: 10px;">
      <strong>DEBUG:</strong><br>
      productId: {{ appStore.calendarSingleData.productId }}<br>
      productTitle: {{ appStore.calendarSingleData.productTitle }}<br>
      productImage: {{ appStore.calendarSingleData.productImage ? 'Yes' : 'No' }}<br>
      isCalendarSingle: {{ appStore.isCalendarSingle }}<br>
      applicationType: {{ appStore.applicationType }}
    </div>
    
    <!-- Min qty text -->
    <div class="min-order-qty-text">
      Minimum order for calendar bundles is {{ minBundleQty }} unit(s)
    </div>

    <!-- Buttons wrapper -->
    <div class="bundle-butons bundle-butons-wrapper calendar">
      
      <!-- Quantity Input -->
      <CalendarQuantityInput
        v-if="appStore.calendarSingleData.productId"
        :product-id="appStore.calendarSingleData.productId"
        v-model="quantity"
        @update:quantity="handleQuantityUpdate"
      />

      <!-- Add to Bundle Button -->
      <a
        v-if="appStore.calendarSingleData.productId"
        class="bundle-butons__item bundle-butons__item--add-to-bundle arrow-right add_to_cart_type_class--bundle"
        :class="{ 'is-disabled': appStore.isOutOfStock }"
        :aria-disabled="appStore.isOutOfStock"
        :data-product_id="appStore.calendarSingleData.productId"
        :data-product_title="appStore.calendarSingleData.productTitle"
        :data-product_image="appStore.calendarSingleData.productImage"
        :data-product_qty="quantity"
        @click="handleAddToBundleClick"
      >
        Add to Bundle
      </a>

      <!-- Back to Themes Button -->
      <button
        class="bundle-butons__item bundle-butons__item--back-to-themes arrow-left"
        @click="navigateToCalendars"
      >
        Back to themes
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useAppStore } from '@/features/imprint/stores/useAppStore';
import CalendarQuantityInput from './components/CalendarQuantityInput.vue';
import { DEBUG_CONFIG } from '@/features/imprint/config/debug.js';

const appStore = useAppStore();

const quantity = ref(25);

const minBundleQty = computed(() => {
  return appStore.isComda ? 100 : 150;
});

const handleQuantityUpdate = (newQty) => {
  quantity.value = newQty;
  appStore.calendarSingleData.quantity = newQty;
  console.log('[CalendarSinglePage] Quantity updated:', newQty);
};

const handleAddToBundleClick = (e) => {
  if (appStore.isOutOfStock) {
    e.preventDefault();
    e.stopPropagation();
    console.warn('[CalendarSinglePage] Add to Bundle blocked: product is Out of Stock');
  }
};

const navigateToCalendars = () => {
  const url = appStore.isComda 
    ? '/collections/promotional-calendars'
    : '/collections/calendars';
  window.location.href = url;
};

onMounted(() => {
  console.log('[CalendarSinglePage] Component mounted');
  console.log('[CalendarSinglePage] isCalendarSingle:', appStore.isCalendarSingle);
  console.log('[CalendarSinglePage] Calendar data:', appStore.calendarSingleData);
  
  // Data is already loaded in appStore.initialize()
  // No need to call loadCalendarSingleData() here
});
</script>

<style scoped lang="scss">
@use '@/styles/utils' as *;

.calendar-single-page {
  margin-top: 20px;
  padding: 20px;
}

.min-order-qty-text {
  margin-top: 7px;
  margin-bottom: 15px;
  text-align: left;
  font-size: 16px;
  font-family: $font-family-base;
  font-weight: 300;
  color: #5A5A5A;
}

.bundle-butons-wrapper.calendar {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.bundle-butons__item {
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 400;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  position: relative;
}

.calendar-single-page{
  .bundle-butons__item,
  .bundle-butons__item--add-to-bundle {
    font-family: $font-family-base;
  }
}

.bundle-butons__item--add-to-bundle {
  background-color: $brand-secondary;
  color: white;
  padding-right: 35px;
}

.bundle-butons__item--add-to-bundle:hover {
  background-color: $brand-secondary;
}

.bundle-butons__item--add-to-bundle.is-disabled {
  background-color: #b0b0b0;
  cursor: not-allowed;
  pointer-events: none;
}

.bundle-butons__item--add-to-bundle.is-disabled:hover {
  background-color: #b0b0b0;
}

.bundle-butons__item--back-to-themes {
  background-color: #969696;
  color: white;
  padding-left: 35px;
}

.bundle-butons__item--back-to-themes:hover {
  background-color: $brand-primary;
}

/* Arrow right (for Add to Bundle button) */
.arrow-right::after {
  content: "";
  border: solid #fff;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  position: absolute;
  top: 38%;
  right: 12px;
}

/* Arrow left (for Back button) */
.arrow-left::before {
  content: "";
  border: solid #fff;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  position: absolute;
  top: 38%;
  left: 12px;
}

@media (max-width: 768px) {
  .bundle-butons-wrapper.calendar {
    flex-direction: column;
    align-items: stretch;
  }
  
  .bundle-butons__item {
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
